import React, { forwardRef } from 'react';
import capitalize from 'lodash/capitalize';
import { Button } from '@gulfwinds/ui-components';

const RecycleBinToggleButton = forwardRef(({ title = 'Recycle Bin', value, onShow, onHide, name, ...props }, ref) => {
  const onClick = value ? onHide : onShow;
  const buttonTitle = value ? `${capitalize(name)} Grid` : title;
  const icon = value ? 'grid-layout' : 'trash';
  return (
    <Button
      ref={ref}
      id='recycle-bin-button'
      primary={value}
      onClick={onClick}
      type="button"
      icon={icon}
      {...props}
    >
      {buttonTitle}
    </Button>
  );
});

export default RecycleBinToggleButton;
